import { localeFor } from "@/lib/dateLocale";

// Messenger-style "last seen" label: "Vu à l'instant" / "Vu il y a X min" / "Vu il y a X h" / "Vu 3 juin".
export const formatLastSeen = (isoStr, t, lang) => {
  if (!isoStr) return "";
  const d = new Date(isoStr);
  const now = new Date();
  const mins = Math.max(0, Math.floor((now - d) / 60000));
  if (mins < 1) return t("chat.seen_now", "Vu à l'instant");
  if (mins < 60) return t("chat.seen_min", "Vu il y a {n} min").replace("{n}", mins);
  const hrs = Math.floor(mins / 60);
  if (d.toDateString() === now.toDateString()) return t("chat.seen_hour", "Vu il y a {n} h").replace("{n}", hrs);
  return `${t("chat.seen", "Vu")} ${d.toLocaleDateString(localeFor(lang), { day: "numeric", month: "short" })}`;
};
